/**
 * LO QUE LA APP NO VENDE DE MOMENTO (15-10).
 *
 * César no quiere el proceso de venta dentro de la app (hoja del 12-10: registro libre,
 * test, llamada, leads) y Francisco, el 15-10: «no la vamos a eliminar, solo quita el acceso
 * y que tampoco funcione por URL». Se cierran la pantalla de planes del cliente (`/planes`,
 * donde se elige y se paga un plan) y el test de venta (`/test`). Las altas, de momento, las
 * da el equipo desde el panel.
 *
 * Nada se ha borrado: las pantallas y su código siguen. Cerradas, sus botones no salen y su
 * dirección lleva a otro sitio (ver `App.js`). Para volver a abrir una: poner su valor en
 * `false`. No hay que tocar nada más.
 *
 * LA VUELTA DE UN PAGO SIGUE ENTRANDO. Stripe devuelve a `/planes` a quien paga el enlace que
 * manda el equipo (`?pago=ok`) y a quien termina una compra empezada antes (`?checkout=`):
 * eso se sigue confirmando, sin enseñar los planes, y de ahí al Inicio.
 *
 * No confundir con `pantallasDelPanel.js` (lo que el panel del EQUIPO no enseña) ni con
 * `pantallasDeLaApp.js` (los interruptores de pantallas del cliente que se guardan en la base).
 */
export const CERRADO_EN_LA_APP = {
    planes: true,
    test: true,
};

/** ¿Se enseñan los planes al cliente (pantalla y botones)? */
export const seVendenPlanes = (cerrado = CERRADO_EN_LA_APP) => !cerrado.planes;

/** ¿Está abierto el test de venta? */
export const hayTestDeVenta = (cerrado = CERRADO_EN_LA_APP) => !cerrado.test;

/** ¿Esta dirección es la vuelta de Stripe a `/planes`? (lo que entra aunque esté cerrada) */
export const esLaVueltaDeUnPago = (search) => {
    const params = new URLSearchParams(search || '');
    return params.get('pago') === 'ok' || ['success', 'canceled'].includes(params.get('checkout'));
};
